<template>
  <div class="columns is-flex is-vcentered">
    <div class="column">
      <b-notification :closable="false">
        <span
          v-html="
            $t('compCarbonFormsRactivitiesComponentsLivestockCardHelp.info-1')
          "
        />
      </b-notification>
    </div>
    <div class="column is-2">
      <img
        src="@/components/carbon/forms/ractivities/components/livestock/image.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardHelp'
}
</script>
